import React from "react"
import ErrorPageComponent from "../ErrorPage/ErrorPageComponent"

interface ErrorBoundaryProps {
    children: React.ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

// Suspense (used by every lazy-loaded route) does not catch render errors,
// so without this a single uncaught error anywhere in the tree unmounts the
// whole app. This wraps the entire app once, at the root.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error("Unhandled render error:", error, errorInfo.componentStack)
    }

    render() {
        if (this.state.hasError) {
            return <ErrorPageComponent />
        }
        return this.props.children
    }
}

export default ErrorBoundary
